import { render, staticRenderFns } from "./RegistrosVerifactu.vue?vue&type=template&id=ad932702"
import script from "./RegistrosVerifactu.vue?vue&type=script&lang=js"
export * from "./RegistrosVerifactu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports